<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center">
      Asignar Entrada a Sesión Virtual
    </ion-title>
    <ion-buttons slot="end" class="buttons-end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid fixed class="search-grid">
    <ion-row>
      <ion-col size="12">
        <ion-segment [(ngModel)]="searchType" (ionChange)="changeSearchType(searchType)">
          <ion-segment-button value="title">
            <ion-label>Título</ion-label>
          </ion-segment-button>
          <ion-segment-button value="id">
            <ion-label>ID del post</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="8">
        <ion-searchbar [placeholder]="searchType === 'title' ? 'Buscar entrada por título...' : 'Buscar entrada por ID del post...'" animated [(ngModel)]="searchTerm"
          (ionInput)="onSearchChange($event)" (keyup.enter)="onSearchEnter($event)" (ionCancel)="onSearchCancel()"
          (ionClear)="onSearchCancel()">
        </ion-searchbar>
      </ion-col>
      <ion-col size="4">
        <ion-button expand="block" fill="solid" color="secondary" (click)="searchPost(searchTerm)">
          <ion-icon name="search" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ion-item *ngFor="let post of posts" class="post-item">
            <ion-thumbnail slot="start" class="post-thumbnail">
              <ion-img [src]="post?.image"></ion-img>
            </ion-thumbnail>
            <ion-label class="post-label">
              <h2 class="post-title">{{ post?.title }}</h2>
              <p class="post-excerpt">{{ post?.excerpt }}</p>
              <p>Fecha de publicación: {{ post?.publication_date?.toDate() | date:'dd/MM/yyyy HH:mm' }}</p>
              <p>
                <ion-badge color="danger">Entrada normal</ion-badge> &nbsp;
                <ion-badge [color]="post?.status === 'active' ? 'success' : 'warning'">{{ post?.status === 'active' ?
                  'Activo' : 'Inactivo' }}</ion-badge> &nbsp;
                <ion-badge color="primary">Webinar</ion-badge>
              </p>
              <p>
                <ion-text color="warning" *ngIf="!!post?.roomId">
                  <ion-icon name="lock-closed"></ion-icon> Entrada asignada a una sesión virtual
                </ion-text>
              </p>
            </ion-label>
            <ion-button [disabled]="!!post?.roomId" fill="clear" color="primary" (click)="alertConfirm(post?.id)">
              Seleccionar
            </ion-button>
          </ion-item>
        </ion-list>
        <ion-text *ngIf="posts?.length === 0" class="ion-text-center" color="medium">
          <div class="ion-text-center">
            No se encontraron resultados. <br>
            <ion-icon name="search" size="large"></ion-icon>
          </div>
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>